"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* tslint:disable */
/* eslint-disable */
tslib_1.__exportStar(require("./AssetsApi"), exports);
tslib_1.__exportStar(require("./CustomerApi"), exports);
tslib_1.__exportStar(require("./InfoApi"), exports);
tslib_1.__exportStar(require("./KnowledgebaseApi"), exports);
tslib_1.__exportStar(require("./OrganizationApi"), exports);
tslib_1.__exportStar(require("./RequestApi"), exports);
tslib_1.__exportStar(require("./RequesttypeApi"), exports);
tslib_1.__exportStar(require("./ServicedeskApi"), exports);
//# sourceMappingURL=index.js.map